module.exports = __webpack_public_path__ + "img/TWIC Chennai.1121cb7a.jpg";